export interface ScheduledDeliveryConfig {
  slots: Record<string, boolean>;
  max_orders_per_slot: number | null;
  min_preorder_hours: number;
}

export function normalizeScheduledDeliveryConfig(
  config: ScheduledDeliveryConfig | null | undefined,
): ScheduledDeliveryConfig | null {
  if (!config) return null;
  const rawBuffer = Number(config.min_preorder_hours);
  const minPreorderHours = Number.isInteger(rawBuffer) && rawBuffer >= 1 ? rawBuffer : 1;
  return { ...config, min_preorder_hours: minPreorderHours };
}
